// SINGLE JS
// rrss share
window.share_noticia = function (type, url) {
  let openUrl = "";
  let title = "";
  let feature = "";
  switch (type) {
    case "fb":
      openUrl =
        "https://www.facebook.com/sharer/sharer.php?u=" + encodeURI(url);
      title = "facebook-share-dialog";
      feature = "width=626, height=436";
      break;
    case "tw":
      openUrl = "https://twitter.com/intent/tweet?text=" + encodeURI(url);
      title = "twitter-share-dialog";
      feature = "width=626, height=436";
      break;
    case "wa":
      openUrl = "https://api.whatsapp.com/send?text=" + encodeURI(url);
      title = "whatsapp-share-dialog";
      feature = "width=626, height=436";
      break;
    case "sms":
      openUrl = "sms:?" + encodeURI(url);
      break;
    case "mail":
      openUrl = "mailto:?" + encodeURI(url);
      break;
  }

  if (type != "mail" && type != "sms") {
    window.open(openUrl, title, feature);
  } else {
    window.location = openUrl;
  }
}

